// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/assets/mountainBorder.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.acta {
  position: relative;
  overflow: hidden;
  min-height: clamp(280px, 70vw, 420px);
  display: flex;
  align-items: center;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: bottom;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}

.acta__bg {
  position: absolute;
  inset: 0;
}
.acta__bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 40%;
  filter: brightness(0.36) saturate(0.6);
}
.acta__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(100deg, rgba(27, 27, 27, 0.7) 0%, rgba(27, 27, 27, 0.5) 50%, rgba(27, 27, 27, 0.4) 100%);
}

.acta__inner {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: clamp(2rem, 5vw, 5rem);
  padding-block: clamp(2rem, 4vw, 3.5rem);
}

/* Badge */
.acta__badge .wws__badge {
  width: clamp(72px, 9vw, 110px) !important;
  height: clamp(72px, 9vw, 110px) !important;
}

/* Centre */
.acta__centre {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--sp-4);
}

.acta__headline {
  font-size: var(--fs-display);
  color: var(--c-cream);
  margin: 0;
  line-height: var(--lh-tight);
}

.acta__sub {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: rgba(220, 204, 180, 0.7);
  margin: 0;
}

.acta__btn {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-3);
  background: var(--accent);
  color: var(--on-accent);
  text-decoration: none;
  font-family: var(--font-body);
  font-weight: 700;
  font-size: var(--fs-xs);
  letter-spacing: var(--track-eyebrow);
  text-transform: uppercase;
  padding: var(--sp-4) clamp(1.5rem, 3vw, 2.5rem);
  transition:
    background var(--dur) var(--ease),
    gap var(--dur) var(--ease);
}
.acta__btn:hover {
  background: var(--accent-hover);
  gap: var(--sp-4);
  color: var(--on-accent);
}

/* Right: note with flower image */
.acta__note {
  display: flex;
  align-items: flex-start;
  gap: var(--sp-4);
  border: 1px solid rgba(220, 204, 180, 0.2);
  border-radius: var(--radius-sm);
  padding: var(--sp-4) var(--sp-5);
  max-width: 20rem;
}

.acta__note-img {
  width: clamp(98px, 7.5vw, 84px);
  height: auto;
  object-fit: contain;
  opacity: 1;
  flex-shrink: 0;
}

.acta__note-text {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  color: var(--c-cream);
  line-height: var(--lh-body);
  margin: 0;
}

@media (max-width: 767.98px) {
  .acta__inner {
    grid-template-columns: 1fr;
    justify-items: center;
    gap: var(--sp-6);
  }
  .acta__badge {
    display: none;
  }
  .acta__note {
    max-width: 22rem;
  }
}

/* ── Mobile font size fixes ── */
@media (max-width: 767.98px) {
  .acta__headline {
    font-size: var(--fs-display);
  }
  .acta__sub {
    font-size: var(--fs-body);
  }
  .acta__note-text {
    font-size: var(--fs-sm);
  }
}

/* ── Mobile design match ── */
@media (max-width: 767.98px) {
  .acta {
    min-height: clamp(280px, 70vw, 420px);
  }
  .acta__headline {
    font-size: clamp(1.8rem, 8vw, 3rem);
  }
  .acta__sub {
    font-size: var(--fs-body);
  }
  .acta__btn {
    font-size: var(--fs-sm);
    /* padding: var(--sp-5) var(--sp-7); */
  }
  .acta__note-text {
    font-size: var(--fs-body);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ApplyCTA.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,mDAAyD;EACzD,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,oHAAoH;AACtH;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA,UAAU;AACV;EACE,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,+CAA+C;EAC/C;;8BAE4B;AAC9B;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,0CAA0C;EAC1C,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,qCAAqC;EACvC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,sCAAsC;EACxC;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".acta {\n  position: relative;\n  overflow: hidden;\n  min-height: clamp(280px, 70vw, 420px);\n  display: flex;\n  align-items: center;\n  background: url(\"../../public/assets/mountainBorder.png\");\n  background-position: bottom;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-size: cover;\n}\n\n.acta__bg {\n  position: absolute;\n  inset: 0;\n}\n.acta__bg-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center 40%;\n  filter: brightness(0.36) saturate(0.6);\n}\n.acta__overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(100deg, rgba(27, 27, 27, 0.7) 0%, rgba(27, 27, 27, 0.5) 50%, rgba(27, 27, 27, 0.4) 100%);\n}\n\n.acta__inner {\n  position: relative;\n  z-index: 2;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: clamp(2rem, 5vw, 5rem);\n  padding-block: clamp(2rem, 4vw, 3.5rem);\n}\n\n/* Badge */\n.acta__badge .wws__badge {\n  width: clamp(72px, 9vw, 110px) !important;\n  height: clamp(72px, 9vw, 110px) !important;\n}\n\n/* Centre */\n.acta__centre {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: var(--sp-4);\n}\n\n.acta__headline {\n  font-size: var(--fs-display);\n  color: var(--c-cream);\n  margin: 0;\n  line-height: var(--lh-tight);\n}\n\n.acta__sub {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  color: rgba(220, 204, 180, 0.7);\n  margin: 0;\n}\n\n.acta__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--sp-3);\n  background: var(--accent);\n  color: var(--on-accent);\n  text-decoration: none;\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: var(--fs-xs);\n  letter-spacing: var(--track-eyebrow);\n  text-transform: uppercase;\n  padding: var(--sp-4) clamp(1.5rem, 3vw, 2.5rem);\n  transition:\n    background var(--dur) var(--ease),\n    gap var(--dur) var(--ease);\n}\n.acta__btn:hover {\n  background: var(--accent-hover);\n  gap: var(--sp-4);\n  color: var(--on-accent);\n}\n\n/* Right: note with flower image */\n.acta__note {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--sp-4);\n  border: 1px solid rgba(220, 204, 180, 0.2);\n  border-radius: var(--radius-sm);\n  padding: var(--sp-4) var(--sp-5);\n  max-width: 20rem;\n}\n\n.acta__note-img {\n  width: clamp(98px, 7.5vw, 84px);\n  height: auto;\n  object-fit: contain;\n  opacity: 1;\n  flex-shrink: 0;\n}\n\n.acta__note-text {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  color: var(--c-cream);\n  line-height: var(--lh-body);\n  margin: 0;\n}\n\n@media (max-width: 767.98px) {\n  .acta__inner {\n    grid-template-columns: 1fr;\n    justify-items: center;\n    gap: var(--sp-6);\n  }\n  .acta__badge {\n    display: none;\n  }\n  .acta__note {\n    max-width: 22rem;\n  }\n}\n\n/* ── Mobile font size fixes ── */\n@media (max-width: 767.98px) {\n  .acta__headline {\n    font-size: var(--fs-display);\n  }\n  .acta__sub {\n    font-size: var(--fs-body);\n  }\n  .acta__note-text {\n    font-size: var(--fs-sm);\n  }\n}\n\n/* ── Mobile design match ── */\n@media (max-width: 767.98px) {\n  .acta {\n    min-height: clamp(280px, 70vw, 420px);\n  }\n  .acta__headline {\n    font-size: clamp(1.8rem, 8vw, 3rem);\n  }\n  .acta__sub {\n    font-size: var(--fs-body);\n  }\n  .acta__btn {\n    font-size: var(--fs-sm);\n    /* padding: var(--sp-5) var(--sp-7); */\n  }\n  .acta__note-text {\n    font-size: var(--fs-body);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
